/**
 * Users Service - API calls voor gebruikersbeheer
 */

import apiFetch from './api';

export interface Role {
  id: number;
  naam: string;
  omschrijving?: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  voornaam?: string;
  achternaam?: string;
  straat?: string;
  huisnummer?: string;
  postcode?: string;
  plaats?: string;
  land?: string;
  telefoon?: string;
  mobiel?: string;
  is_active: boolean;
  is_superuser: boolean;
  rol_id?: number;
  rol?: Role;
  werknemer_id?: number;
  created_at: string;
  updated_at?: string;
}

export interface UserCreate {
  username: string;
  email: string;
  password: string;
  voornaam?: string;
  achternaam?: string;
  straat?: string;
  huisnummer?: string;
  postcode?: string;
  plaats?: string;
  land?: string;
  telefoon?: string;
  mobiel?: string;
  rol_id?: number;
  werknemer_id?: number;
  is_active?: boolean;
  is_superuser?: boolean;
}

export interface UserUpdate {
  username?: string;
  email?: string;
  password?: string;
  voornaam?: string;
  achternaam?: string;
  straat?: string;
  huisnummer?: string;
  postcode?: string;
  plaats?: string;
  land?: string;
  telefoon?: string;
  mobiel?: string;
  rol_id?: number;
  werknemer_id?: number;
  is_active?: boolean;
  is_superuser?: boolean;
}

export interface UserFilters {
  skip?: number;
  limit?: number;
  actief?: boolean;
  rol_id?: number;
  zoek?: string;
}

export interface UserListResponse {
  items: User[];
  total: number;
  page: number;
  page_size: number;
}

export const usersService = {
  async getAll(filters: UserFilters = {}): Promise<UserListResponse> {
    const params = new URLSearchParams();

    if (filters.skip !== undefined) params.append('skip', filters.skip.toString());
    if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters.actief !== undefined) params.append('actief', filters.actief.toString());
    if (filters.rol_id !== undefined) params.append('rol_id', filters.rol_id.toString());
    if (filters.zoek) params.append('zoek', filters.zoek);

    return apiFetch(`/api/v1/users?${params.toString()}`);
  },

  async getById(id: number): Promise<User> {
    return apiFetch(`/api/v1/users/${id}`);
  },

  async create(data: UserCreate): Promise<User> {
    return apiFetch('/api/v1/users', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id: number, data: UserUpdate): Promise<User> {
    return apiFetch(`/api/v1/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id: number): Promise<void> {
    return apiFetch(`/api/v1/users/${id}`, {
      method: 'DELETE',
    });
  },

  async permanentDelete(id: number): Promise<void> {
    return apiFetch(`/api/v1/users/${id}/permanent`, {
      method: 'DELETE',
    });
  },

  async getRoles(): Promise<Role[]> {
    return apiFetch('/api/v1/users/roles/list');
  },
};
